<template>
  <div>
    <img :class="dashboard ? 'small_img' : 'img'" v-if="type=='registration_new' && !message.includes('uploaded')" src="/static/images/icons/tick_new_theme_icon.svg" alt />
    <img :class="dashboard ? 'small_img' : 'img'" v-else-if="type=='registration_modified'" src="/static/images/icons/edit_new_theme_icon.svg" alt />
    <img :class="dashboard ? 'small_img' : 'img'" v-else-if="type=='registration_deleted'" src="/static/images/icons/delete_new_theme_icon.svg" alt />
    <img :class="dashboard ? 'small_img' : 'img'" v-else-if="type=='attachment'" src="/static/images/icons/upload_new_theme_icon.svg" alt />
    <img :class="dashboard ? 'small_img' : 'img'" v-else src="/static/images/icons/new_notification.svg" alt />

    <img :class="dashboard ? 'small_img' : 'img'" v-if="type=='expiring'" src="/static/images/icons/expiring_soon.svg" alt />
    <img
      :class="dashboard ? 'small_img' : 'img'"
      v-if="type=='welcome' || type=='mail'"
      src="/static/images/icons/profile_icon.svg"
      alt
    />
    <img :class="dashboard ? 'small_img' : 'img'" v-if="type=='active'" src="/static/images/icons/active_green_icon.svg" alt />
    <img :class="dashboard ? 'small_img' : 'img'" v-if="type=='pending'" src="/static/images/icons/pending_icon.svg" alt />
    <p v-if="type==''"></p>
  </div>
</template>

<script>
export default {
  props: ['type', 'dashboard', 'message'],
  data() {
    return {};
  },
};
</script>

<style scoped>
.added_icon {
  color: #4c9e45;
}
.expired_icon {
  color: #b00505;
}
.clock_icon {
  font-size: 12px;
  position: absolute;
  top: 55%;
  left: 69%;
  background-color: white;
  padding: 0px;
  border-radius: 20px;
  width: 11px;
}
.img {
  width: 24px;
  height: 24px;
}

.small_img {
  width: 16px;
  height: 20px;
}
/* @media (min-width:768px) and (max-width: 991px) {
  img {
    width: 22px;
    height: 22px;
  }
}
@media screen and (max-width: 767px) {
  img {
    width: 18px;
    height: 18px;
  }
} */
</style>
